export default "__VITE_ASSET__B43WdhYy__"